import { ReactNode } from 'react'

import { UserConsentInput, UserConsentSubtypeEnum, UserConsentTypeEnum } from '~/app/generated/graphql'

const getNodeText: (node: ReactNode) => string = (node: ReactNode) => {
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node)
  }

  if (Array.isArray(node)) {
    return node.map(getNodeText).join('')
  }

  if (typeof node === 'object' && node && 'props' in node) {
    const props = (node as { props: Record<string, unknown> }).props
    if ('text' in props) {
      return getNodeText(props.text as ReactNode)
    }
  }

  return ''
}

export function formatConsentToAPIFormat(consent: {
  consentType: UserConsentTypeEnum
  consentSubtype?: UserConsentSubtypeEnum
  value: boolean
  label?: ReactNode
  showMore?: ReactNode
}): UserConsentInput {
  const formattedConsent: UserConsentInput = {
    given: consent.value,
    consentType: consent.consentType,
  }

  if (consent.label) {
    formattedConsent.agreementText = [getNodeText(consent.label), getNodeText(consent.showMore)]
      .map(part => part.trim())
      .filter(Boolean)
      .join(' ')
  }

  if (consent.consentSubtype) formattedConsent.consentSubtype = consent.consentSubtype

  return formattedConsent
}
